/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { AxiosApiResponse } from '@common/types/api';

export interface AdvancedUserSearchResult {
  entraId: string;
  displayName: string | null;
  email: string | null;
  trackupId: string | null;
  hasLocalAccount: boolean;
  currentRole: string | null;
}

export interface AdvancedUserCompanyAccess {
  companyId: number;
  userId: string;
  role: string;
}

export class AdvancedUser {
  static search(query: string, companyId?: number | null, config?: { signal?: AbortSignal }): AxiosApiResponse<AdvancedUserSearchResult[]> {
    return axiosInstance.get(`/api/v1/admin/advanced-users/search`, {
      signal: config?.signal,
      params: { query, companyId: companyId ?? undefined },
    });
  }

  static setCompanyAccess(entraId: string, email: string, companyId: number, role: string): AxiosApiResponse<AdvancedUserCompanyAccess> {
    return axiosInstance.post(`/api/v1/admin/advanced-users/company-access`, {
      payload: { entraId, email, companyId, role },
    });
  }
}

export default AdvancedUser;
